<template>
  <div class="future-event">
    <img src="/widget-preview.png" />

    <div
      class="dialog-confirm"
      role="alertdialog"
      aria-labelledby="future-event-header"
      aria-modal="true"
      data-pc-name="dialog"
    >
      <div class="dialog-confirm--body">
        <slot name="icon"><IconTimer /></slot>

        <div class="dialog-confirm--header">
          <div class="modal-header" id="future-event-header">
            <template v-if="type === 'scorecard'">This campaign is not live yet.</template>
            <template v-if="type === 'event'">This event is not live yet.</template>            
          </div>
        </div>

        <div class="dialog-confirm--message">
          <p>
            <template v-if="type === 'scorecard'">
              No events in this campaign have data yet.
            </template>
            <template v-if="type === 'event'">
              To view and update the event configuration, click the button below.
            </template>          
          </p>
        </div>
      </div>
      <div v-if="type === 'event'" class="dialog-confirm--footer">
        <Button severity="primary" :link="`/events/${eventId}/edit`">Edit Event</Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from '../global/Button.vue';

import IconTimer from '@/icons/IconTimer.svg?component';

defineProps<{
  type: 'scorecard' | 'event'
  eventId?: number;
}>();
</script>

<style lang="scss">
.future-event {
  position: relative;

  img {
    width: 100%;
  }

  .dialog-confirm {
    display: flex;
    flex-direction: column;
    pointer-events: auto;
    position: relative;
    top: -100px;
    width: 100%;

    @media screen and (min-width: 768px) {
      left: calc(50% - 225px);
      position: absolute;
      top: calc(50% - 150px);
      width: 450px;
    }

  }

  .modal-header {
    justify-content: center;
  }  

  .dialog-confirm--footer {
    border-top: 0;
    justify-content: center;
    padding-top: 0;
  }
}
</style>
